import React, {PureComponent} from 'react';

import style from './LiveEventItem.css';

export default class LiveEventItem extends PureComponent {
  render() {
    let {thread} = this.props;

    return (
        <div className={style.live_event}>
          <p>{thread.title}</p>
        </div>
    )
  }
}
